import {GoodsType} from "../../../entities/goods/model/types/goods-type";
import {FilterSelectorsType, MetaPaginationType, SuggestionType} from "../model/types";
import {ServerSearchResponseType} from "../../../shared/api/types";
import {utilsTypeof} from "../../../shared/utils/utilsTypeof";

export type MapperServerSearchResultType = {
    products: GoodsType[],
    suggestions: SuggestionType,
    search: { suggest: string },
    metaPagination: MetaPaginationType,
    filterSelectors: FilterSelectorsType
}

function getRandomInt(max: number) {
    return Number((Math.random() * max).toFixed(2))
}

export const mapServerSearchResult = (data: ServerSearchResponseType): MapperServerSearchResultType => {
    return {
        products: Array.isArray(data.items) ? data.items.map(item => ({
            ...item,
            price: item?.test_price ,
            old_price: null,
            currency: '$'
        })) : [],
        search: {
            suggest: data?.suggest ?? "",
        },
        suggestions: Array.isArray(data.autocomplete) ? data.autocomplete : [],
        metaPagination: {
            count: +data?.count ?? 0,
            start_from: +data?.start_from ?? 0,
            limit: 20
        },
        filterSelectors: utilsTypeof.isObject(data.selectors) ? data.selectors : {}
    }
}